import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialStorage} from '../types'

import {
  currentMaterialStoragesQueryOptions,
  CurrentMaterialStoragesQueryKey
} from './currentMaterialStoragesQueryOptions'

export {CurrentMaterialStoragesQueryKey}

type Params<TReturn = MaterialStorage[]> = {
  plantId: string
  options?: Omit<UseQueryOptions<MaterialStorage[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useCurrentMaterialStorages = <TReturn = MaterialStorage[]>({
  plantId,
  options
}: Params<TReturn>) =>
  useQuery<MaterialStorage[], AxiosError, TReturn>({
    ...currentMaterialStoragesQueryOptions(plantId),
    ...options
  })
